<button
  mat-flat-button
  color="primary"
  style="height: 32px"
  [disabled]="!user"
  (click)="$event.stopImmediatePropagation(); openDialog()"
>
  Add Funds
</button>
